import React, { useState } from 'react'
import { getSearchTerm } from '../../utils/constants'

// Review the Google-Shopping query before spending a monthly lookup (F3).
// Prefills from the last stored term, else the product title's "Brand Model"
// head. On confirm, the caller fires the lookup as a one-item job (no 504).
export default function MarketPriceLookupModal({ title, initialTerm, onRun, onClose }) {
  const [term, setTerm] = useState(initialTerm || getSearchTerm(title || '') || '')
  return (
    <div className="modal-overlay" style={{ zIndex: 70 }} onClick={onClose}>
      <div className="modal-content" style={{ maxWidth: 420 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3 style={{ margin: 0 }}>Look up market price</h3>
          <button className="modal-close" onClick={onClose} aria-label="Close">×</button>
        </div>
        <div className="modal-body-scroll">
          <div className="form-group">
            <label htmlFor="mp-term">Search term (review before it fires)</label>
            <input
              id="mp-term" type="text" value={term} onChange={e => setTerm(e.target.value)} autoFocus
              aria-label="search term" style={{ width: '100%' }}
            />
            <div style={{ fontSize: 11, color: '#6b7280', marginTop: 4 }}>
              This is the exact query we search on Google Shopping. Edit it to match the real product.
            </div>
          </div>
        </div>
        <div className="modal-footer" style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button type="button" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</button>
          <button
            type="button" className="btn btn-sm btn-primary"
            disabled={!term.trim()} onClick={() => onRun(term.trim())}
          >
            Run lookup
          </button>
        </div>
      </div>
    </div>
  )
}
